<app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>

<mat-card>
    <mat-card-content>
        <h1>
            Domande frequenti dei nostri utenti
        </h1>
        <p>
            In questa sezione puoi consultare le domande più frequenti che abbiamo
            ricevuto dai nostri utenti.
        </p>
        <mat-accordion *ngFor="let x of faq;">
            <mat-expansion-panel (opened)="panelOpenState = true"
                (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                    <mat-panel-title style="font-weight: bold;"> Domanda:</mat-panel-title>
                      <mat-panel-description> {{x.domanda}} </mat-panel-description>
                </mat-expansion-panel-header>
                <p style="font-weight:bold;"> Risposta: </p><p>{{x.risposta}}</p>
            </mat-expansion-panel>
    </mat-accordion>
    </mat-card-content>
</mat-card>
